<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      'active': cekActive(item),
      'disabled': item.disabled
    }"
  >
    <span
      v-if="item.headers"
      class="navigation-header d-block text-capitalize text-body mt-1 mb-0 font-medium-3"
    >{{ t(item.headers) }}</span>
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
      @click="hideGuide"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate font-medium-1">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { mapMutations } from 'vuex'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  mounted() {
  },
  methods: {
    ...mapMutations('userguide', {
      setShowGuid: 'SET_SHOW_GUIDE',
    }),
    cekActive(item) {
      if (this.$route.params.page === item.route.params.page) {
        document.title = `IOH Platform - ${item.title}`
        return true
      }
      return false
    },
    hideGuide() {
      this.setShowGuid(false)
    },
  },
  setup(props) {
    const {
      linkProps,
    } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()
    return {
      linkProps,
      // ACL
      canViewVerticalNavMenuLink,
      // i18n
      t,
    }
  },

}
</script>

<style scoped>
/deep/ .main-menu.menu-light .navigation > li ul li ul a {
    padding: 10px 15px 10px 15px !important;
}
</style>
